import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ldbetoetivxwgfomyqoc.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxkYmV0b2V0aXZ4d2dmb215cW9jIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzODYyNzYsImV4cCI6MjA4OTk2MjI3Nn0.Lfxy9HY1ij185n6k1bKjvH9ZwHcPJrG0CWxFto668NQ'

export const supabase = createClient(supabaseUrl, supabaseKey)
